import Link from "next/link";

import { useSelector } from "react-redux";

import User from "../Offcanvas/User";
import { useAppContext } from "@/context/Context";
import Nav from "../Nav";
import { useState } from "react";
import PopupForm from "@/components/PopupForm/PopupForm";

const HeaderRightTwo = ({ btnClass, btnText, userType }) => {
  const {
    mobile,
    setMobile,
    search,
    setSearch,
    setCourses,
    cartToggle,
    setCart,
    isOpen,
    setIsOpen,
  } = useAppContext();

  const { total_items } = useSelector((state) => state.CartReducer);

  return (
    <div className="header-right">
      <div className="rbt-main-navigation d-none d-xl-block">
        <Nav />
      </div>
      <ul className="account-access quick-access">
        {/* <li
          className="access-icon"
          style={{ marginLeft: "15px", marginRight: "5px", marginTop: "2.5px" }}
        >
          <Link
            className={`search-trigger-active rbt-round-btn ${
              search ? "" : "open"
            }`}
            href=""
            onClick={() => {
              setSearch(!search);
              setCourses(true);
            }}
          >
            <i className="feather-search"></i>
          </Link>
        </li> */}

        {/* 
        <li className="access-icon rbt-mini-cart">
          <Link
            className="rbt-cart-sidenav-activation rbt-round-btn"
            href="#"
            onClick={() => setCart(!cartToggle)}
          >
            <i className="feather-shopping-cart"></i>
            <span className="rbt-cart-count">{total_items}</span>
          </Link>
        </li> */}

        <li className="account-access rbt-user-wrapper d-none d-xl-block">
          <div className="rbt-btn-wrapper d-none d-xl-block">
            <Link
              // target="_blank"
              href={"/all-courses"}
              className="rbt-btn3"
            >
              Compare University
            </Link>
          </div>
        </li>
        <li>
          <div className="rbt-btn-wrapper d-none d-xl-block">
            <button onClick={() => setIsOpen(true)} className="rbt-btn3">
              Enquire Now
            </button>
          </div>
        </li>
      </ul>

      <div className="mobile-menu-bar d-block d-xl-none">
        <div className="hamberger">
          <button
            className="hamberger-button rbt-round-btn"
            onClick={() => setMobile(!mobile)}
          >
            <i className="feather-menu"></i>
          </button>
        </div>
      </div>

      {isOpen && <PopupForm TimeOutSeconds={100} />}
    </div>
  );
};

export default HeaderRightTwo;
